import http from '@/utils/http'
import { register } from '@/api/url'

export function addRegisterInfo(param) {
  return http({
    url: register.addRegisterInfo,
    method: 'post',
    data: param
  })
}

export function getAuthInfo() {
  return http({
    url: register.getAuthInfo,
    method: 'post'
  })
}

export function addCompanyInfo(param) {
  return http({
    url: register.addCompanyInfo,
    method: 'post',
    data: param
  })
}

export function addCompanyUser(param) {
  return http({
    url: register.addCompanyUser,
    method: 'post',
    data: param
  })
}

export function modifyRegisterInfo(param) {
  return http({
    url: register.modifyRegisterInfo,
    method: 'post',
    data: param
  })
}

export function modifyCompanyInfo(param) {
  return http({
    url: register.modifyCompanyInfo,
    method: 'post',
    data: param
  })
}

export function modifyCompanyUser(param) {
  return http({
    url: register.modifyCompanyUser,
    method: 'post',
    data: param
  })
}

export function openRegisterFxPay(param) {
  return http({
    url: register.openRegisterFxPay,
    method: 'post',
    data: param
  })
}
